export default "__VITE_PUBLIC_ASSET__23356b93__"